<template>
  <div class="navbar-wrapper">
    <el-menu class="navbar" mode="horizontal">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>

      <breadcrumb class="breadcrumb-container"></breadcrumb>

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="handleAvatarUpload" style="display:block;">更换头像</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="toggleCareMode" style="display:block;">
              <svg-icon v-if="!careMode" icon-class="eye" style="margin-right:6px;vertical-align:middle;"></svg-icon>
              <svg-icon v-else icon-class="eye" style="margin-right:6px;vertical-align:middle;color:#3b6ff5;"></svg-icon>
              {{ careMode ? '关怀模式 ✓' : '开启关怀模式' }}
            </span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="openPasswordDialog()" style="display:block;">设置密码</span>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>

    <!-- 跑马灯公告：仅桌面端，脱离 el-menu，叠在 navbar 上方水平居中 -->
    <div v-if="announcements.length && device !== 'mobile'" class="navbar-marquee">
      <span class="marquee-icon">📢</span>
      <div class="marquee-track">
        <div class="marquee-content" :style="marqueeStyle">
          <span v-for="(item, index) in announcements" :key="item.id" class="marquee-item">
            {{ item.announcement }}<span v-if="index < announcements.length - 1" class="marquee-sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          </span>
          <span class="marquee-sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span v-for="(item, index) in announcements" :key="'dup-' + item.id" class="marquee-item">
            {{ item.announcement }}<span v-if="index < announcements.length - 1" class="marquee-sep">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          </span>
        </div>
      </div>
    </div>

    <!-- 修改密码弹窗 -->
    <el-dialog title="修改密码" :visible.sync="showPasswordDialog" width="80%">
      <el-form label-width="80px">
        <el-form-item label="旧密码：">
          <el-input v-model="oldPassword" type="password" style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="新密码：">
          <el-input v-model="newPassword" type="password" style="width: 80%"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 头像上传隐藏 input -->
    <input
      ref="avatarInput"
      type="file"
      accept="image/jpeg,image/png,image/jpg"
      style="display: none"
      @change="onAvatarFileChange"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Hamburger from '@/components/Hamburger'
import Breadcrumb from '@/components/Breadcrumb'
import store from "../../../store";
import {updateNewPassword, uploadIcon} from '@/api/login';
import {signCosUrl} from '@/api/qrAdvertise';
import {fetchList} from '@/api/announcement';

export default {
  components: {
    Hamburger,
    Breadcrumb
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'careMode',
      'device'
    ]),
    marqueeStyle() {
      if (!this.announcements.length) return {}
      const duration = Math.max(this.announcements.length * 5, 10)
      return {
        animationDuration: duration + 's'
      }
    }
  },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      showPasswordDialog: false,
      announcements: []
    };
  },
  created() {
    this.loadAnnouncements()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    toggleCareMode() {
      const newMode = !this.careMode
      this.$store.dispatch('ToggleCareMode')
      this.$message({
        message: newMode ? '已开启关怀模式，字体更大更清晰' : '已关闭关怀模式',
        type: 'success',
        duration: 2000
      })
    },
    handleAvatarUpload() {
      this.$refs.avatarInput.click()
    },
    onAvatarFileChange(e) {
      const file = e.target.files[0]
      if (!file) return
      // 校验文件类型和大小
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片')
        this.$refs.avatarInput.value = ''
        return
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB')
        this.$refs.avatarInput.value = ''
        return
      }
      const loading = this.$loading({ text: '头像上传中...' })
      uploadIcon(file).then(response => {
        const url = response.data.url
        // COS 私有桶需要签名后才能访问
        return signCosUrl(url).then(signRes => {
          this.$store.commit('SET_AVATAR', signRes.data || url)
          this.$message({ message: '头像更换成功！', type: 'success' })
        })
      }).catch(() => {
        this.$message.error('头像上传失败，请重试')
      }).finally(() => {
        loading.close()
        this.$refs.avatarInput.value = ''
      })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    handleDialogConfirm() {

      let data={};
      data.username=store.getters.name;
      data.oldPassword=this.oldPassword;
      data.newPassword=this.newPassword;

      updateNewPassword(data).then(response => {

        this.$message({
          message: '修改成功！',
          type: 'success'
        });

        this.showPasswordDialog=false;
      })
    },
    //
    openPasswordDialog() {
      this.showPasswordDialog = true;
    },
    loadAnnouncements() {
      fetchList().then(res => {
        const list = (res.data && res.data.list) ? res.data.list : []
        this.announcements = list
          .sort((a, b) => new Date(b.createTime || 0) - new Date(a.createTime || 0))
          .slice(0, 5)
      }).catch(() => {
        // 静默失败
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.navbar-wrapper {
  position: relative; // 跑马灯 absolute 定位的参照
}

// 跑马灯：脱离 el-menu，叠在 navbar 上方水平+垂直居中
.navbar-marquee {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-flex;
  align-items: center;
  height: 30px;
  z-index: 2; // 叠在 navbar 内容之上
  border-radius: 6px;
  background: linear-gradient(90deg, #fef7e0 0%, #fff8e8 100%);
  border: 1px solid #f0e4c0;
  overflow: hidden;
  box-sizing: border-box;
  max-width: 880px;
}

.navbar-marquee .marquee-icon {
  flex-shrink: 0;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
}

.navbar-marquee .marquee-track {
  flex: 1;
  overflow: hidden;
  position: relative;
  height: 30px;
  line-height: 30px;
  min-width: 0;
}

.navbar-marquee .marquee-content {
  display: inline-flex;
  white-space: nowrap;
  animation: marquee-scroll 20s linear infinite;
}

.navbar-marquee .marquee-item {
  color: #8b6914;
  font-size: 12px;
  flex-shrink: 0;
}

.navbar-marquee .marquee-sep {
  color: #d4b96a;
  font-size: 12px;
}

.navbar-marquee .marquee-track:hover .marquee-content {
  animation-play-state: paused;
}

@keyframes marquee-scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}

.navbar {
  height: 56px;
  line-height: 56px;
  border-radius: 0px !important;
  border-bottom: 1px solid #e8eaed;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

  .hamburger-container {
    line-height: 56px;
    height: 56px;
    float: left;
    padding: 0 16px;

    &:hover {
      background: #f2f3f5;
    }
  }

  .breadcrumb-container {
    float: left;
    line-height: 56px;
  }

  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }

  .avatar-container {
    height: 56px;
    display: inline-block;
    position: absolute;
    right: 24px;

    .avatar-wrapper {
      cursor: pointer;
      height: 56px;
      display: flex;
      align-items: center;
      position: relative;

      .user-avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        border: 2px solid #e8eaed;
        transition: border-color .2s;
      }

      &:hover .user-avatar {
        border-color: #3b6ff5;
      }

      .el-icon-caret-bottom {
        margin-left: 6px;
        color: #86909c;
        font-size: 12px;
        transition: color .2s;
      }

      &:hover .el-icon-caret-bottom {
        color: #3b6ff5;
      }
    }
  }
}

// ==================== 移动端适配 ====================
@media (max-width: 768px) {
  .navbar-wrapper {
    position: static; // 移动端不需要跑马灯定位参照
  }

  .navbar {
    height: 48px;
    line-height: 48px;

    .hamburger-container {
      height: 48px;
      line-height: 48px;
      padding: 0 10px;
    }

    ::v-deep .breadcrumb-container,
    ::v-deep .app-breadcrumb {
      display: none !important; // 移动端隐藏面包屑，节省空间
    }

    .avatar-container {
      height: 48px;
      right: 12px;

      .avatar-wrapper {
        height: 48px;

        .user-avatar {
          width: 28px;
          height: 28px;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue